(function() {

	var Application = include("springroll.Application"),
		Sprite = include("PIXI.Sprite"),
		Texture = include("PIXI.Texture");

	var UIClue = function(state, id)
	{
		this.state = state;

		Sprite.call(this, Texture.fromFrame("container_clue_" + id));
		
		this.id = id;
		this.anchor.x = this.anchor.y = 0.5;
		
		this.onClick = this.onClick.bind(this);
	};

	// Extend MovieClip
	var s = Sprite.prototype;
	var p = UIClue.prototype = Object.create(s);
	
	Object.defineProperty(p, "scaleX", {
		get: function() { return this.scale.x; },
		set: function(value)
		{
			this.scale.x = value;
		}
	});
	
	Object.defineProperty(p, "scaleY", {
		get: function() { return this.scale.y; },
		set: function(value)
		{
			this.scale.y = value;
		}
	});

	p.enable = function()
	{
		this.interactive = this.buttonMode = true;
		
		this.on("click", this.onClick);
		this.on("tap", this.onClick);
	};
	
	p.disable = function()
	{
		this.interactive = this.buttonMode = false;
		
		this.off("click", this.onClick);
		this.off("tap", this.onClick);
	};
	
	p.onClick = function()
	{
		this.state.playVO("Elmo_" + this.id + "End");
	};

	p.destroy = function()
	{
		s.destroy.call(this);
		this.state = null;
	};

	namespace('heist').UIClue = UIClue;
}());